/*
 * Module for interacting with API endpoints relating to the Citizen management feature
 */
import { getFullyQualifiedAPIUrl, apiGet } from "@/core/api";
export const apiCitizenChecks = {
    getForCitizen: (citizenId) => apiGet(`citizens/${citizenId}/citizenChecks`),
    getIdentityReportPdfViewLink: (citizenId) => apiGet(`citizens/${citizenId}/viewToken`)
        .then(viewToken => getFullyQualifiedAPIUrl(`citizens/${citizenId}/citizenChecks/identityReport/pdf?token=${encodeURIComponent(viewToken)}`)),
};
